<div class="stepper">
  <div
    class="circle"
    [ngClass]="
      currentStep === steps.CartridgeSelection ? 'activated' : 'deactivated'
    "
  >
    1
  </div>
  <div>
    <markant-icon-button
      icon="m_minus"
      class="vertical-step"
    ></markant-icon-button>
    <span class="text-align">{{
      'usageRight.addCartridgesDialog.stepper.first' | transloco
    }}</span>
  </div>

  <div
    class="circle"
    [ngClass]="
      currentStep === steps.OrganizationDataCompletion
        ? 'activated'
        : 'deactivated'
    "
  >
    2
  </div>
  <div>
    <markant-icon-button
      icon="m_minus"
      class="vertical-step"
    ></markant-icon-button>
    <span class="text-align">{{
      'usageRight.addCartridgesDialog.stepper.second' | transloco
    }}</span>
  </div>

  <div
    class="circle"
    [ngClass]="currentStep === steps.Confirmation ? 'activated' : 'deactivated'"
  >
    3
  </div>
  <div>
    <markant-icon-button
      icon="m_minus"
      class="vertical-step"
    ></markant-icon-button>
    <span class="text-align">{{
      'usageRight.addCartridgesDialog.stepper.third' | transloco
    }}</span>
  </div>
</div>
